import React, { useRef, useState, useEffect } from 'react'
import {
  getMaterialsGroups,
  getUsersToConfig,
  relateProfileWithGroup,
  relateProfileWithUser,
} from '@auteco/services/snopServices'
import { Button, Card, TextField } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { Alert } from '@auteco/components/snopComponents/Alert'
import AddIcon from '@material-ui/icons/Add'
import VisibilityIcon from '@material-ui/icons/Visibility'
import { verifyNullValue } from '@auteco/utils/verifyNullValue'
import { AiFillEdit } from 'react-icons/ai'
import { initialAlert } from '@auteco/constants'
import MaterialTable from '@material-table/core'
import { DialogCreateProfile } from '../DialogCreateProfile'
import { DialogConsultProfile } from '../DialogConsultProfile'
import { DialogDelete } from '../DialogDelete'
import useStyles from './styles'

const initialDialog = {
  open: false,
  onClose: () => {},
  type: '',
}

const initialidsRef = { profile: '', idToRelate: '' }

const RelateSection = ({
  profiles,
  getProfiles,
  materialsList,
  getMaterialsListApi,
}) => {
  const [itemsToRelate, setItemsToRelate] = useState([])
  const [dialogInfo, setDialogInfo] = useState(initialDialog)
  const [idsRefToRelate, setidsRefToRelate] = useState(initialidsRef)
  const [alertInfo, setAlertInfo] = useState(initialAlert)

  const classes = useStyles()
  const optionsFilter = [{ name: 'Grupo' }, { name: 'Usuarios' }]
  const idsRef = useRef({})

  useEffect(() => {
    getMaterialsListApi()
  }, [])

  const rowStyle = (rowData, index) => {
    if (index % 2 !== 0) {
      return { backgroundColor: '#f0f0f0' }
    }
    return {}
  }

  const columns = [
    {
      title: 'Grupo',
      field: 'gnombre',
      sorting: false,
    },
    {
      title: 'Perfil',
      field: 'pnombre',
      sorting: false,
    },
    {
      title: 'Usuario',
      field: 'nombre',
      sorting: false,
    },
  ]

  const getItemsToRelate = async ({ type }) => {
    setItemsToRelate([])
    idsRef.current = { ...idsRef.current, idToRelate: '', type }
    if (type !== '') {
      if (type === 'Grupo') {
        const { grupos } = await getMaterialsGroups()
        if (grupos) {
          setItemsToRelate(grupos)
        }
      } else {
        const { usuarios } = await getUsersToConfig()
        if (usuarios) {
          setItemsToRelate(usuarios)
        }
      }
    } else {
      setItemsToRelate([])
    }
  }

  const onOpenDialog = ({ type }) => {
    setDialogInfo({
      type,
      open: true,
      onClose: () => setDialogInfo(initialDialog),
    })
  }

  const handleChangeId = ({ type, value }) => {
    if (value === '' && 'profile') {
      setItemsToRelate([])
      idsRef.current = { idToRelate: '', type: '', [type]: value }
    } else {
      idsRef.current = { ...idsRef.current, [type]: value }
    }

    setidsRefToRelate((previdsRef) => ({ ...previdsRef, [type]: value }))
  }

  const verifyValue = ({ value, param }) => (value === null ? '' : value[param])

  const onCloseAlert = () => {
    setAlertInfo(initialAlert)
  }
  const onRelate = async () => {
    if (idsRef.current.type === 'Grupo') {
      const body = {
        perfil_id: idsRef.current.profile,
        grupo_id: idsRef.current.idToRelate,
      }
      const { success } = await relateProfileWithGroup({ params: body })
      if (success === 1) {
        getProfiles()
        getMaterialsListApi()
        setAlertInfo({
          title: 'Completado',
          content: 'El vínculo se ha completado con éxito',
          textBtn1: 'Cerrar',
          textBtn2: '',
          open: true,
          onClose: onCloseAlert,
          funcBtn: onCloseAlert,
        })
      } else {
        setAlertInfo({
          title: 'Error',
          content: 'No se pudo realizar la vinculación',
          textBtn1: 'Cerrar',
          textBtn2: '',
          open: true,
          onClose: onCloseAlert,
          funcBtn: onCloseAlert,
        })
      }
    } else {
      const body = {
        perfil_id: idsRefToRelate.profile,
        usuario_id: idsRefToRelate.idToRelate,
      }
      const { success } = await relateProfileWithUser({ params: body })
      if (success === 1) {
        getProfiles()
        getMaterialsListApi()
        setAlertInfo({
          title: 'Completado',
          content: 'El vínculo se ha completado con éxito',
          textBtn1: 'Cerrar',
          textBtn2: '',
          open: true,
          onClose: onCloseAlert,
          funcBtn: onCloseAlert,
        })
      } else {
        setAlertInfo({
          title: 'Error',
          content: 'No se pudo realizar la vinculación',
          textBtn1: 'Cerrar',
          textBtn2: '',
          open: true,
          onClose: onCloseAlert,
          funcBtn: onCloseAlert,
        })
      }
    }
  }
  return (
    <>
      <Alert
        title={alertInfo.title}
        content={alertInfo.content}
        textBtn1={alertInfo.textBtn1}
        textBtn2={alertInfo.textBtn2}
        funcBtn={alertInfo.funcBtn}
        open={alertInfo.open}
        onClose={onCloseAlert}
      />
      {dialogInfo.type === 'create' && (
        <DialogCreateProfile
          open={dialogInfo.open}
          onClose={dialogInfo.onClose}
          getProfiles={getProfiles}
        />
      )}
      {dialogInfo.type === 'consult' && (
        <DialogConsultProfile
          open={dialogInfo.open}
          onClose={dialogInfo.onClose}
          profiles={profiles}
          getProfiles={getProfiles}
        />
      )}
      {dialogInfo.type === 'delete' && (
        <DialogDelete
          options={profiles}
          type="perfil"
          functionSuccess={getProfiles}
          open={dialogInfo.open}
          onClose={dialogInfo.onClose}
        />
      )}
      <Card className={classes.container}>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {profiles.length > 0 && (
            <>
              <Autocomplete
                options={profiles}
                value={
                  profiles.find(
                    (option) => option.id === idsRef?.current?.profile,
                  ) || null
                }
                className={classes.textField}
                getOptionLabel={(option) => option.nombre}
                renderInput={(params) => (
                  <TextField {...params} label="Perfiles" variant="outlined" />
                )}
                onChange={(e, newValue) =>
                  handleChangeId({
                    type: 'profile',
                    value: verifyValue({ value: newValue, param: 'id' }),
                  })
                }
              />
              <Autocomplete
                options={optionsFilter}
                value={
                  optionsFilter.find(
                    (option) => option.name === idsRef.current.type,
                  ) || null
                }
                className={classes.textField}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Vincular con"
                    variant="outlined"
                  />
                )}
                onChange={(e, newValue) =>
                  getItemsToRelate({
                    type: verifyNullValue({ value: newValue, param: 'name' }),
                  })
                }
              />
            </>
          )}
          {itemsToRelate.length > 0 && (
            <>
              <Autocomplete
                options={itemsToRelate}
                value={
                  itemsToRelate.find(
                    (option) => option.id === idsRef.current.idToRelate,
                  ) || null
                }
                className={classes.textField}
                getOptionLabel={(option) =>
                  idsRef.current.type === 'Grupo'
                    ? option.nombre
                    : `${option.nombre} ${option.apellido}`
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={idsRef.current.type}
                    variant="outlined"
                  />
                )}
                onChange={(e, newValue) =>
                  handleChangeId({
                    type: 'idToRelate',
                    value: verifyValue({ value: newValue, param: 'id' }),
                  })
                }
              />
              <Button
                variant="contained"
                className={classes.relateBtn}
                color="primary"
                onClick={onRelate}
              >
                Vincular
              </Button>
            </>
          )}
        </div>
      </Card>
      <Card className={classes.btnsContainer}>
        <Button
          variant="contained"
          className={classes.actionBtn}
          endIcon={<AddIcon />}
          onClick={() => onOpenDialog({ type: 'create' })}
        >
          Crear perfil
        </Button>
        <Button
          variant="contained"
          className={classes.actionBtn}
          endIcon={<VisibilityIcon />}
          onClick={() => onOpenDialog({ type: 'consult' })}
        >
          Consultar perfiles
        </Button>
        <Button
          variant="contained"
          className={classes.actionBtn}
          endIcon={<AiFillEdit />}
          onClick={() => onOpenDialog({ type: 'delete' })}
        >
          Editar o eliminar perfil
        </Button>
      </Card>
      {materialsList.length > 0 && (
        <MaterialTable
          title=""
          data={materialsList}
          columns={columns}
          style={{ marginTop: '20px' }}
          options={{
            sorting: false,
            thirdSortClick: false,

            pageSize: 20,
            pageSizeOptions: [20, 50, 100],
            headerStyle: {
              backgroundColor: '#4c75aa',
              color: '#f1f1f1',
              fontSize: '14px',
              fontWeight: 700,
              position: 'sticky', zIndex: '10'
            },
            maxBodyHeight: '500px',
            rowStyle: (rowData, index) => ({
              backgroundColor: index % 2 === 0 ? 'white' : '#f0f0f0',
              padding: '5px',
              fontSize: '12px',
            }),
          }}
        />
      )}
    </>
  )
}

export { RelateSection }
